module.exports = __webpack_public_path__ + "img/straight-rail-horizontal-stone-path-remnants.d2d76952.png";